module.exports = __webpack_public_path__ + "img/banner02.8a176a7d.jpg";